module.exports = __webpack_public_path__ + "img/turkey_1.85cad15e.jpg";